import React, { useState, useEffect } from "react";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { doc, setDoc, getDoc, getDocs, collection, where, query, updateDoc, arrayUnion } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Select } from 'antd';
import styles from "../../../styles/Register.module.css"
import OtpInputContainer from "../../../components/FlowComponents/OtpInputContainer/OtpInputContainer.jsx";
import { Link, useLocation } from "react-router-dom";
import { auth, db } from "../../../firebase-config.js";
import { findCourseRegistrationPriceById } from "../../../service/findCoursePriceById.js";
import { updateUserEarnings } from "../../../service/updateEarnings/updateUserEarnings.js";
import { getCurrentTimestamp } from "../../../service/time/getCurrentTimestamp.js";
import { notification, Drawer, Upload, Modal } from "antd";
import ButtonComponent from "../../../components/CssComponents/ButtonComponent/ButtonComponent.jsx";
import PhoneInputComponent from "../../../components/CssComponents/PhoneInput/PhoneInputComponent.jsx";
import ArLogo from "../../../components/CssComponents/ArLogo/ArLogo.jsx";
import RegisterLogo from "../../../components/CssComponents/RegisterLogo/RegisterLogo.jsx";
import { findUserWhoReferedMe } from "../../../service/findUsers/findUserWhoReferedMe.js";
import { savePayment, saveTransaction } from "../../../service/saveTransactions.js";
import qrCode from "../../../assets/qr_code.jpg"
import { UploadOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from 'uuid'; // Import uuid for unique file names



const StudentRegister = () => {
  // Fetch courses from Firestore
  const location = useLocation(); // Get the current location object
  const [otp, setOtp] = useState('');




  const [error, setError] = useState(false)
  const [helpText, setHelpText] = useState('')
  const [uid, setUid] = useState('');
  // const [selectedFile, setSelectedFile] = useState(null);
  const [confirmationResult, setConfirmationResult] = useState(null);

  const [packages, setPackages] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);


  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [pendingUploads, setPendingUploads] = useState([]);

  const [formData, setFormData] = useState({
    isActive: false,
    firstName: "",
    lastName: "",
    phone: "",
    buyItemIdsArray: [],
    dateOfBirth: "",
    aadharNumber: "",
    panNumber: "",
    address: "",
    accountNumber: "",
    accountType: "",
    ifscCode: "",
    referralId: "",
    userTypes: "team_leader",
    myARID: "",
    createdAt: "",
    updatedAt: "",
    uid: "",
  });



  // Fetch batch data when selectedPackage changes
  useEffect(() => {
    const fetchBatches = async () => {
      if (
        !selectedPackage ||
        !selectedPackage.packageContainingBatches ||
        !Array.isArray(selectedPackage.packageContainingBatches) ||
        selectedPackage.packageContainingBatches.length === 0
      ) {
        setBatches([]);
        return;
      }

      try {
        const batchIds = selectedPackage.packageContainingBatches;
        const batchCollection = collection(db, "lms_batch");
        const batchQuery = query(batchCollection, where("batchId", "in", batchIds));
        const batchSnapshot = await getDocs(batchQuery);

        const batches = batchSnapshot.docs.map((doc) => ({
          batchId: doc.data().batchId,
          batchName: doc.data().batchName || "Unnamed Batch",
        }));

        setBatches(batches);
      } catch (error) {
        console.error("Error fetching batch options:", error);
        setBatches([]);
        notification.error({
          message: "Error Fetching Batches",
          description: "Failed to load batch options. Please try again.",
          placement: "topRight",
          duration: 3,
        });
      }
    };

    fetchBatches();
  }, [selectedPackage]);


  console.log("selectedBatches", selectedBatch)

  const handlePreview = async (file) => {
    setPreviewImage(file.url);
    setPreviewVisible(true);
  };

  const handleCancelPreview = () => setPreviewVisible(false);

  // Handle file removal
  const handleRemove = (file) => {
    setPendingUploads(prev => prev.filter(f => f.uid !== file.uid));
    setFileList(prev => prev.filter(f => f.uid !== file.uid));
  };




  // Handle file selection
  // const handleFileChange = ({ fileList: newFileList }) => {
  //   // Validate and prevent duplicate filenames
  //   const uniqueFiles = newFileList.filter((file, index, self) =>
  //     index === self.findIndex((f) => f.name === file.name)
  //   );

  //   if (uniqueFiles.length !== newFileList.length) {
  //     notification.warning({
  //       message: "Duplicate File",
  //       description: "A file with the same name already exists.",
  //       placement: "topRight",
  //       duration: 3,
  //     });
  //   }

  //   setPendingUploads(uniqueFiles);
  //   setFileList(uniqueFiles.map(file => ({
  //     ...file,
  //     status: 'done',
  //     url: file.url || URL.createObjectURL(file.originFileObj)
  //   })));
  // };

  const handleFileChange = ({ fileList: newFileList }) => {
    const uniqueFiles = newFileList.filter((file, index, self) =>
      index === self.findIndex((f) => f.name === file.name)
    );

    if (uniqueFiles.length !== newFileList.length) {
      notification.warning({
        message: "Duplicate File",
        description: "A file with the same name already exists.",
        placement: "topRight",
        duration: 3,
      });
    }

    // Revoke previous URLs to prevent memory leaks
    fileList.forEach((file) => {
      if (file.url && file.url.startsWith("blob:")) {
        URL.revokeObjectURL(file.url);
      }
    });

    setPendingUploads(uniqueFiles);
    setFileList(uniqueFiles.map(file => ({
      ...file,
      status: 'done', // Reflect that upload is pending
      url: file.url || URL.createObjectURL(file.originFileObj)
    })));
  };

  // Clean up URLs on component unmount
  useEffect(() => {
    return () => {
      fileList.forEach((file) => {
        if (file.url && file.url.startsWith("blob:")) {
          URL.revokeObjectURL(file.url);
        }
      });
    };
  }, [fileList]);



  const handlePackageChange = (value) => {
    const selectedPkg = packages.find((item) => item.packageId === value) || null;
    setSelectedPackage(selectedPkg);
  };

  const handleBatchChange = (value) => {
    const selectedBatch = batches.find((item) => item.batchId === value) || null;
    setSelectedBatch(selectedBatch);
  };








  useEffect(() => {
    window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
      'size': 'invisible',
      'callback': (response) => {
        console.log('reCAPTCHA solved');
      }
    });

    return () => {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
      }
    };
  }, []);


  useEffect(() => {
    const fetchPublishedPackages = async () => {
      try {
        const q = query(
          collection(db, "lms_package"),
          where("packageStatus", "==", true)
        );
        const snapshot = await getDocs(q);

        // Remove undefined or incomplete package data
        const packages = snapshot.docs.map(doc => doc.data());

        setPackages(packages);
      } catch (error) {
        console.error("Error fetching published packages:", error);
      }
    };

    fetchPublishedPackages();
  }, []);




  const handleOtpChange = (otpComing) => {
    setOtp(otpComing);
  };

  const generateMyARID = () => {
    const randomNumbers = Math.floor(100000 + Math.random() * 900000);
    return `CL${randomNumbers}`;
  };

  const sendVerificationCode = (e) => {
    e.preventDefault();
    const appVerifier = window.recaptchaVerifier;
    signInWithPhoneNumber(auth, formData.phone, appVerifier)
      .then((result) => {
        setConfirmationResult(result);
        notification.success({
          message: 'OTP Sent',
          description: 'OTP sent to your phone',
          placement: 'topRight',
          duration: 3, // Display for 3 seconds
        });

      })
      .catch((error) => {
        console.error('Error sending OTP:', error);
        notification.error({
          message: 'OTP Sending Failed',
          description: 'Failed to send OTP. Please try again.',
          placement: 'topRight',
          duration: 3, // Display for 3 seconds
        });

      });
  };

  const verifyOtp = (e) => {
    e.preventDefault();
    if (!confirmationResult) {
      notification.info({
        message: 'OTP Request Needed',
        description: 'First request the OTP',
        placement: 'topRight',
        duration: 3, // Display for 3 seconds
      });

      return;
    }
    confirmationResult.confirm(otp)
      .then(async (result) => {
        // auth user 
        const { user } = result;
        setUid(user.uid);
        setFormData(prevData => ({ ...prevData, uid: user.uid }));
        notification.success({
          message: 'Verification Successful',
          description: `Phone number verified! User: ${user.uid}`,
          placement: 'topRight',
          duration: 3,
        });

        // Check if the user data already exists
        const userDocRef = doc(db, "users", user.uid);
        const userDocSnapshot = await getDoc(userDocRef);

        if (userDocSnapshot.exists()) {
          // If user data exists, use it and prevent overwriting myARID
          // fetching the data if exists & updating formData
          const existingData = userDocSnapshot.data();
          setFormData(existingData);
        } else {
          const createdAt = getCurrentTimestamp();
          // If user data does not exist, generate a new myARID
          const myARID = generateMyARID();
          setFormData(prevData => ({ ...prevData, myARID, createdAt }));
        }
      })
      .catch((error) => {
        console.error('Error verifying OTP:', error);
        notification.error({
          message: 'Verification Failed',
          description: 'Failed to verify OTP. Please try again.',
          placement: 'topRight',
          duration: 3,
        });
      });
  };

  // Upload all pending files to Firebase
  // const uploadFilesToFirebase = async () => {
  //   try {
  //     const storage = getStorage();
  //     const uploadPromises = pendingUploads.map(async (file) => {
  //       // Generate unique filename using UUID
  //       const uniqueFileName = `${uuidv4()}-${file.name}`;
  //       const storageRef = ref(storage, `lms_payments/${uniqueFileName}`);
  //       const snapshot = await uploadBytes(storageRef, file.originFileObj);
  //       return getDownloadURL(snapshot.ref);
  //     });

  //     const urls = await Promise.all(uploadPromises);
  //     return urls;
  //   } catch (error) {
  //     console.error("Error uploading files:", error);
  //     throw error;
  //   }
  // };

  const uploadFilesToFirebase = async () => {
    try {
      const storage = getStorage();
      const uploadPromises = pendingUploads.map(async (file) => {
        const uniqueFileName = `${uuidv4()}-${file.name}`;
        const storageRef = ref(storage, `lms_payments/${uniqueFileName}`);
        const snapshot = await uploadBytes(storageRef, file.originFileObj);
        return getDownloadURL(snapshot.ref);
      });

      const urls = await Promise.all(uploadPromises);
      return urls;
    } catch (error) {
      console.error("Error uploading files:", error);
      notification.error({
        message: "File Upload Failed",
        description: "Failed to upload payment proof. Please try again.",
        placement: "topRight",
        duration: 3,
      });
      throw error;
    }
  };

  const addUserToFirestore = async () => {
    try {
      console.log("selected package", selectedPackage)

      if (selectedPackage?.packageId) {

        // Upload all files
        const uploadedUrls = await uploadFilesToFirebase();

        // Validate Proof URLs
        if (!uploadedUrls.length) {
          notification.warning({
            message: "Upload Required",
            description: "Please upload at least one proof of payment before proceeding.",
            placement: "topRight",
            duration: 3,
          });
          return;
        }

        if (!formData.referralId) {
          notification.warning({
            message: "Referral ID Required",
            description: "Please enter a valid Referral ID.",
            placement: "topRight",
            duration: 3,
          });
          return;
        }

        // const referringUserUid = await findUserWhoReferedMe(formData.referralId);

        const referringUserUid = await findUserWhoReferedMe(formData.referralId).catch((error) => {
          console.error("Error finding referrer:", error);
          notification.error({
            message: "Referral Error",
            description: "Failed to validate Referral ID. Please contact admin.",
            placement: "topRight",
            duration: 3,
          });
          return null;
        });

        console.log("Referring User UID:", referringUserUid);

        if (!referringUserUid) {
          notification.error({
            message: "No Referrer Found",
            description: "Contact Admin to resolve this issue.",
            placement: "topRight",
            duration: 3,
          });
          console.error("No referrer found for user:", uid);
          return;
        }

        if (formData?.buyItemIdsArray?.some((entry) => entry.buyItemId === selectedPackage.packageId)) {
          notification.warning({
            message: "Already Enrolled",
            description: "You have already enrolled.",
            placement: "topRight",
            duration: 3,
          });
          return;
        }



        const newItemEntry = {
          buyItemId: selectedPackage.packageId || "ar_id",
          buyItemType: selectedPackage.packageType || "ar_type",
          buyItemPrice: selectedPackage.packagePrice || 0,
          buyItemRegistrationPrice: selectedPackage.registrationPrice || 0,
          proofUrls: uploadedUrls,
          status: "pending",
        };


        await setDoc(doc(db, "users", uid), { ...formData, uid: uid, buyItemIdsArray: arrayUnion(newItemEntry) }, { merge: true });

        // bacth will available when type is package_lc
        // this is just to filter the joined bacth
        // there is no price in batch things 
        // this is just for categorization
        if (selectedBatch?.batchId) {
          if (formData?.buyItemIdsArray?.some((entry) => entry.buyItemId === selectedBatch.batchId)) {
            notification.warning({
              message: "Batch Already Enrolled",
              description: "You have already enrolled.",
              placement: "topRight",
              duration: 3,
            });
            return;
          }
          const newItemEntryBatch = {
            buyItemId: selectedBatch.batchId || "bacth_id",
            buyItemType: selectedBatch.batchType || "batch",
            status: "pending",
          };
          await updateDoc(doc(db, "users", uid), {
            buyItemIdsArray: arrayUnion(newItemEntryBatch),
            updatedAt: getCurrentTimestamp(),
          });
        }


        if (referringUserUid) {
          await updateUserEarnings(
            {
              referringUserUid: referringUserUid,
              buyItemPrice: (Number(selectedPackage?.packagePrice) || 0) + (Number(selectedPackage?.registrationPrice) || 0),
              buyItemId: selectedPackage.packageId || "ar_id",
              studentUid: uid,
            }
          )
        }

        await saveTransaction({
          type:"student_payment",
          direction:"credit",
          uid: uid,
          amount: (Number(selectedPackage?.packagePrice) || 0) + (Number(selectedPackage?.registrationPrice) || 0),
          itemId: selectedPackage.packageId || "ar_id",
          reason: `Purchased ${selectedPackage?.packageName} (${selectedPackage?.packageType})`,
          proofUrls: uploadedUrls,
        });


        await savePayment({
          uid: uid,
          amount: (Number(selectedPackage?.packagePrice) || 0) + (Number(selectedPackage?.registrationPrice) || 0),
          itemId: selectedPackage.packageId || "ar_id",
          reason: `Purchased ${selectedPackage?.packageName} (${selectedPackage?.packageType})`,
          proofUrls: uploadedUrls,
        })


        notification.success({
          message: "Congratulations!",
          description: "You have purchased the item successfully.",
          placement: "topRight",
          duration: 3,
        });

      } else {
        notification.error({
          message: "Error while register",
          description: "Please attach payment proof",
          placement: 'topRight',
          duration: 3
        })
        return;
      }

      notification.success({
        message: 'Registration Successful',
        description: 'User data saved to Firestore!',
        placement: 'topRight',
        duration: 3,
      });
    } catch (error) {
      console.error("Error adding user to Firestore: ", error);
      notification.error({
        message: 'Registration Error',
        description: `Error adding user to Firestore: ${error.message}`,
        placement: 'topRight',
        duration: 3,
      });
    }
  };




  // handle input changes 
  const handleChange = async (e) => {
    const { name, value } = e.target;

    if (name === "referralId") {
      setFormData({ ...formData, [name]: value });

      try {
        const foundUser = await findUserWhoReferedMe(value);
        if (foundUser) {
          setError(false);
          setHelpText(`User found: ${foundUser.firstName} ${foundUser.lastName}`);
        } else {
          setError(true);
          setHelpText("No user found. Please enter a valid Referral ID.");
        }
      } catch (error) {
        console.error("Error validating referral ID:", error);
        setError(true);
        setHelpText("Error validating Referral ID. Please try again.");
        notification.error({
          message: "Referral Validation Error",
          description: "Failed to validate Referral ID. Please try again.",
          placement: "topRight",
          duration: 3,
        });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  const updatePhoneNumber = (phoneNumber) => {
    setFormData((prevData) => ({
      ...prevData,
      phone: phoneNumber,
    }));
  };



  // const handleRegister = async (e) => {
  //   e.preventDefault();

  //   const updatedAt = getCurrentTimestamp();
  //   setFormData({ ...formData, updatedAt })

  //   if (uid) {
  //     addUserToFirestore();
  //   } else {
  //     notification.warning({
  //       message: 'Verification Required',
  //       description: 'Please verify OTP first',
  //       placement: 'topRight',
  //       duration: 3,
  //     });
  //   }
  // };

  const handleRegister = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.phone) {
      notification.warning({
        message: "Phone Number Required",
        description: "Please enter a valid phone number.",
        placement: "topRight",
        duration: 3,
      });
      return;
    }

    if (!uid) {
      notification.warning({
        message: "Verification Required",
        description: "Please verify OTP first.",
        placement: "topRight",
        duration: 3,
      });
      return;
    }

    if (!formData.firstName || !formData.lastName || !formData.dateOfBirth) {
      notification.warning({
        message: "Required Fields Missing",
        description: "Please fill in First Name, Last Name, and Date of Birth.",
        placement: "topRight",
        duration: 3,
      });
      return;
    }

    if (!selectedPackage) {
      notification.warning({
        message: "Package Selection Required",
        description: "Please select a package.",
        placement: "topRight",
        duration: 3,
      });
      return;
    }

    if (!formData.referralId) {
      notification.warning({
        message: "Referral ID Required",
        description: "Please enter a valid Referral ID.",
        placement: "topRight",
        duration: 3,
      });
      return;
    }

    const updatedAt = getCurrentTimestamp();
    setFormData({ ...formData, updatedAt });

    await addUserToFirestore();
  };

  return (
    <>
      <div className={styles.RegisterBackground}>
        <div className={styles.RegisterContainer}>

          <div className={styles.RegisterImage}>
            <RegisterLogo />
          </div>

          <div className={styles.formSection}>
            <ArLogo />
            <div className={styles.headingText}>Student Registration</div>
            <form className={styles.formContainer}>

              <div id="recaptcha-container"></div>

              <div className={styles.labelInputWrapper}>
                <div className={styles.labelText}>Phone Number <sup>*</sup></div>
                <PhoneInputComponent
                  value={formData.phone}
                  onChange={updatePhoneNumber}
                />
              </div>

              <ButtonComponent
                onClick={sendVerificationCode}
                className={""}
                buttonText={"Send OTP"}
              />

              <div className={styles.labelInputWrapper}>
                <div className={styles.labelText}>Enter Otp <sup>*</sup></div>
                <OtpInputContainer onOtpChange={handleOtpChange} />
              </div>

              <ButtonComponent
                onClick={verifyOtp}
                className={""}
                buttonText={"Verify OTP"}
              />

              <div className={styles.labelInputWrapper}>
                <div className={styles.labelText}>First Name <sup>*</sup></div>
                <input
                  type="text"
                  className={styles.input}
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Enter first name"
                  required
                />
              </div>

              <div className={styles.labelInputWrapper}>
                <div className={styles.labelText}>Last Name <sup>*</sup></div>
                <input
                  type="text"
                  className={styles.input}
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter last name"
                  required
                />
              </div>

              <div className={styles.labelInputWrapper}>
                <div className={styles.labelText}>Date of Birth <sup>*</sup></div>
                <input
                  type="date"
                  className={styles.input}
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.labelInputWrapper}>
                <div className={styles.labelText}>Referral ID <sup>*</sup></div>
                <input
                  required
                  type="text"
                  className={styles.input}
                  name="referralId"
                  value={formData.referralId}
                  onChange={handleChange}
                  placeholder="Enter Referral ID"
                />
              </div>

              {
                error && (
                  <div style={{ color: error ? 'red' : 'green' }}>{helpText}</div>
                )
              }


              <div className={styles.labelInputWrapper}>
                <div className={styles.labelText}>Select Package <sup>*</sup></div>
                <Select
                  required
                  name="selectedPackage"
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  placeholder="Select Package"
                  value={selectedPackage?.packageId || null}
                  onChange={handlePackageChange}
                  options={packages.map(item => {
                    let packageType = ""
                    if (item.packageType === 'package_lc') {
                      packageType = " (Live Clasess)"
                    } else if (item.packageType === 'package_dp') {
                      packageType = " (Digital Product)"
                    }
                    return {
                      value: item.packageId,
                      label: item.packageName + packageType
                    }
                  }) || []}
                />
              </div>

              {
                ((selectedPackage?.packageType === 'package_lc') && (selectedPackage?.packageContainingBatches?.length > 0)) && (
                  <div className={styles.labelInputWrapper}>
                    <div className={styles.labelText}>Select Batches</div>
                    <Select
                      required
                      name="selectedBatch"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      placeholder="Select batches"
                      value={selectedBatch?.batchId || null}
                      onChange={handleBatchChange}
                      options={batches.map((item) => (
                        {
                          label: item.batchName,
                          value: item.batchId
                        }
                      )) || []}
                    />
                  </div>
                )
              }



              {/* QR Code Section */}
              <div className={styles.labelInputWrapper}>
                {
                  selectedPackage?.packageType === 'package_lc' && (
                    <div className={styles.labelText}>
                      Registration Fee: {selectedPackage?.registrationPrice}</div>
                  )
                }
                {
                  selectedPackage?.packageType === 'package_dp' && (
                    <div className={styles.labelText}>
                      Package Price: {selectedPackage?.packagePrice}</div>
                  )
                }
                <img src={qrCode} alt="QR Code" className={styles.qrCodeImage} />
              </div>


              {/* Upload Section */}
              <div className={styles.labelInputWrapper}>
                <div className={styles.labelText}>Payment Proof</div>
                <Upload
                  fileList={fileList}
                  onChange={handleFileChange}
                  onPreview={handlePreview}
                  onRemove={handleRemove}
                  listType="picture-card"
                  accept="image/*"
                  beforeUpload={() => false} // Prevent auto-upload
                >
                  {fileList.length < 5 && (
                    <div>
                      <UploadOutlined />
                      <div style={{ marginTop: 8 }}>Upload Screenshot</div>
                    </div>
                  )}
                </Upload>

                <Modal
                  open={previewVisible}
                  footer={null}
                  onCancel={handleCancelPreview}
                >
                  <img alt="Preview" style={{ width: "100%" }} src={previewImage} />
                </Modal>
              </div>


              <ButtonComponent
                onClick={handleRegister}
                className={""}
                buttonText={"Register"}
              />

              <Link
                to="/student?action=login"
                style={{
                  textDecoration: 'none',
                }}
              >
                <div className={styles.alr}>already a member? <span>Login</span></div>
              </Link>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentRegister;
